module.exports = __webpack_public_path__ + "img/9788925539621.54d392aa.jpg";